export const SPELL_MASTER_LIST = "spell_master_list";
export const SPELL_MASTER_LIST_SUCCESSFULL = "spell_master_list_successfull";
export const ADDITEM_TO_SPELL_MASTER_LIST = "addItem_to_spell_master_list";
export const ADDITEM_TO_SPELL_MASTER_LIST_SUCCESSFULL = "addItem_to_spell_master_list_successfull";
export const UPDATE_SPELL_MASTER_LIST ='update_spell_master_list';
export const UPDATE_SPELL_MASTER_LIST_SUCCESSFULL ='update_spell_master_successfull';
export const PARENT_SPELL ='parent_spell';
export const PARENT_SPELL_SUCCESSFULL ='parent_spell_successfull';